import { Injectable } from '@angular/core'
import { SearchParams } from '@ftr/routing-paths'
import { Store } from '@ngxs/store'
import { SetSearchTermAction } from '../../../store/this-recording-search'

export enum FormGroupMembers {
  SearchTerm = 'searchTerm',
  SearchType = 'searchType',
}

@Injectable({
  providedIn: 'root',
})
export class SearchBarService {
  private searchedFromUrl: string | undefined

  constructor(private readonly store: Store) {}

  setUpSearch(searchTerm: string): void {
    this.store.dispatch(new SetSearchTermAction(searchTerm))
  }

  setLastUrlBeforeSearching(routerUrl: string): void {
    const rxSearchUrl = new RegExp(SearchParams.SearchPageNumber, 'gi')
    if (!rxSearchUrl.test(routerUrl)) {
      this.searchedFromUrl = routerUrl
    }
  }

  getSearchedFromUrl(): string | undefined {
    return this.searchedFromUrl
  }
}
